import { ContactBlock } from "@/components/common/ContactBlock";
import { AppointmentForm } from "@/components/common/AppointmentForm";
import { IMG } from "@/data/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="relative h-[260px] overflow-hidden md:h-[340px]">
        <img src={IMG.building} alt="Medicity Hospital building" className="h-full w-full object-cover object-[center_60%]" />
        <div className="absolute inset-0 bg-gradient-to-r from-maroon-ink/90 to-maroon-ink/30" />
        <div className="container-x absolute inset-0 flex flex-col justify-center">
          <p className="eyebrow text-amber-300">संपर्क · Contact</p>
          <h1 className="font-display mt-3 text-4xl text-white sm:text-5xl lg:text-6xl">हम आपकी सेवा में</h1>
        </div>
      </section>
      <ContactBlock />
      <AppointmentForm />
    </div>
  );
}
